<template>
  <section class="close-summary">
    <div class="close-summary__hero" v-if="item.total">
      <span class="close-summary__hero-label">Total Fechamento</span>
      <strong class="close-summary__hero-value">{{ item.total }}</strong>
      <small class="close-summary__hero-hint">Total arrecadado no período</small>
    </div>

    <div class="close-summary__group">
      <h6 class="close-summary__title">Pagamentos</h6>
      <div class="metrics-grid">
        <article class="metric metric--money">
          <span class="metric__label">Dinheiro</span>
          <strong class="metric__value">{{ item.money }}</strong>
        </article>
        <article class="metric metric--pix">
          <span class="metric__label">PIX</span>
          <strong class="metric__value">{{ item.pix }}</strong>
        </article>
        <article class="metric metric--credit">
          <span class="metric__label">Cartão de Crédito</span>
          <strong class="metric__value">{{ item.credit }}</strong>
        </article>
        <article class="metric metric--debit">
          <span class="metric__label">Cartão de Débito</span>
          <strong class="metric__value">{{ item.debit }}</strong>
        </article>
        <article class="metric metric--discount">
          <span class="metric__label">Descontos Concedidos</span>
          <strong class="metric__value">{{ item.quantity.discount | currency("R$ ", 2, {
            thousandsSeparator: ".",
            decimalSeparator: ",",
          }) }}</strong>
        </article>
        <article class="metric metric--adicional">
          <span class="metric__label">Total Adicionais</span>
          <strong class="metric__value">{{ item.totalAditional | currency("R$ ", 2, {
            thousandsSeparator: ".",
            decimalSeparator: ",",
          }) }}</strong>
        </article>
      </div>
    </div>

    <div class="close-summary__group">
      <h6 class="close-summary__title">Quantidades</h6>
      <div class="metrics-grid metrics-grid--compact">
        <article class="metric metric--neutral">
          <span class="metric__label">Postagens</span>
          <strong class="metric__value">{{ item.quantity.prepost }}</strong>
        </article>
        <article class="metric metric--neutral">
          <span class="metric__label">Valor de Postagem</span>
          <strong class="metric__value">{{ item.quantity.total | currency("R$ ", 2, {
            thousandsSeparator: ".",
            decimalSeparator: ",",
          }) }}</strong>
        </article>
        <article class="metric metric--neutral">
          <span class="metric__label">Autorizações</span>
          <strong class="metric__value">{{ item.quantity.authorization }}</strong>
        </article>
        <article class="metric metric--neutral">
          <span class="metric__label">PLP Terceiros</span>
          <strong class="metric__value">{{ item.quantity.plp }}</strong>
        </article>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: "PdvUserTimelineClose",
  props: ["item"],
};
</script>
<style scoped>
.close-summary {
  padding: 12px 16px 14px;
  border-top: 1px solid #faecd8;
  background: #fffdf8;
}

.close-summary__hero {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 14px;
  padding: 12px 14px;
  border: 1px solid #d9ecff;
  border-radius: 8px;
  background: #ecf5ff;
}

.close-summary__hero-label {
  color: #409eff;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.4px;
  text-transform: uppercase;
}

.close-summary__hero-value {
  color: #303133;
  font-size: 20px;
  line-height: 1.2;
}

.close-summary__hero-hint {
  color: #909399;
  font-size: 11px;
}

.close-summary__group + .close-summary__group {
  margin-top: 14px;
}

.close-summary__title {
  margin: 0 0 8px;
  color: #606266;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.4px;
  text-transform: uppercase;
}

.metrics-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

.metrics-grid--compact {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.metric {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 10px 12px;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  background: #fff;
}

.metric__label {
  color: #909399;
  font-size: 11px;
  font-weight: 600;
}

.metric__value {
  color: #303133;
  font-size: 13px;
  line-height: 1.3;
}

.metric--money .metric__value {
  color: #67c23a;
}

.metric--pix .metric__value {
  color: #409eff;
}

.metric--credit .metric__value,
.metric--debit .metric__value {
  color: #606266;
}

.metric--discount .metric__value {
  color: #f56c6c;
}

.metric--adicional .metric__value {
  color: #e6a23c;
}

@media (max-width: 768px) {
  .metrics-grid,
  .metrics-grid--compact {
    grid-template-columns: 1fr;
  }
}
</style>
